// extracted by mini-css-extract-plugin
export default {"input":"WSInputDate-module_input-GOX_z"};